<template>
  <!-- eslint-disable -->
  <b-sidebar
    id="add-new-container"
    :visible="isAdd"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    no-close-on-backdrop
    @change="(val) => $emit('update:is-add', val)"
  >
    <template #default="{ hide }">
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ isEdit ? 'Editar' : 'Agregar nuevo' }} contenedor</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="[hide(), resetForm()]" />
      </div>

      <validation-observer #default="{ invalid }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="onSubmit">
          <validation-provider #default="{ errors }" name="Fecha estimada de envio" rules="requeridoE">
            <b-form-group label="Fecha estimada de envio" label-for="estimatedShippingDate">
              <b-form-input
                id="estimatedShippingDate"
                v-model="items.estimatedShippingDate"
                type="date"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Packing list" rules="requeridoE">
            <b-form-group label="Packing list" label-for="packingList">
              <b-form-input
                id="packingList"
                v-model="items.packingList"
                trim
                placeholder="PL-001"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Origen" rules="requeridoE">
            <b-form-group label="Origen" label-for="origin">
              <b-form-input
                id="origin"
                v-model="items.origin"
                trim
                placeholder="China"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Destino" rules="requeridoE">
            <b-form-group label="Destino" label-for="destination">
              <b-form-input
                id="destination"
                v-model="items.destination"
                trim
                placeholder="Peru"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="{ errors }" name="Estado" rules="requeridoE">
            <b-form-group label="Estado" label-for="status">
              <b-form-select
                id="status"
                v-model="items.status"
                :options="statusOptions"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <div class="d-flex mt-2 justify-content-end">
            <b-button
              :disabled="invalid || isDisabled"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              <b-spinner v-if="isDisabled" small />
              <span v-if="isDisabled" class="px-1">guardando...</span>
              <span v-else>{{ isEdit ? 'Actualizar' : 'Agregar' }}</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="[hide(), resetForm()]"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
/* eslint-disable*/
import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ContainerService from '@/services/ContainerService'

Vue.use(BootstrapVue)

export default {
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isAdd: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      required,
      isEdit: false,
      isDisabled: false,
      items: this.emptyItems(),
      statusOptions: [
        { value: 1, text: 'REGISTRO SIN EXCEL' },
        { value: 2, text: 'REGISTRO CON EXCEL SIN VALIDAR' },
        { value: 3, text: 'REGISTRO CON EXCEL VALIDADO CON ERRORES' },
        { value: 4, text: 'REGISTRO CON EXCEL VALIDADO SIN ERRORES' },
      ],
    }
  },
  methods: {
    emptyItems() {
      return {
        id: null,
        estimatedShippingDate: '',
        packingList: '',
        origin: '',
        destination: '',
        status: 1,
      }
    },
    getData(items) {
      if (items && Object.entries(items).length !== 0) {
        this.items = {
          id: items.id,
          estimatedShippingDate: this.formatDateForInput(items.estimatedShippingDate),
          packingList: items.packingList || '',
          origin: items.origin || '',
          destination: items.destination || '',
          status: Number(items.status || 1),
        }
        this.isEdit = true
      } else {
        this.items = this.emptyItems()
        this.isEdit = false
      }
    },
    formatDateForInput(value) {
      if (!value) return ''
      return String(value).slice(0, 10)
    },
    resetForm() {
      if (this.$refs.refFormObserver) this.$refs.refFormObserver.reset()
      this.items = this.emptyItems()
      this.isEdit = false
      this.isDisabled = false
    },
    buildPayload() {
      return {
        estimatedShippingDate: this.items.estimatedShippingDate,
        packingList: this.items.packingList,
        origin: this.items.origin,
        destination: this.items.destination,
        status: Number(this.items.status),
      }
    },
    async onSubmit() {
      this.$refs.refFormObserver.validate().then(async success => {
        if (success) {
          this.isDisabled = true
          const payload = this.buildPayload()
          let resp = ''

          if (this.isEdit) {
            resp = await ContainerService.updateContainer(this.items.id, payload, this.$store)
          } else {
            resp = await ContainerService.saveContainer(payload, this.$store)
          }

          if (resp) {
            this.$swal({
              title: this.isEdit ? 'Actualizado' : 'Anadido',
              text: 'El contenedor ha sido ' + (this.isEdit ? 'actualizado.' : 'registrado.'),
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            this.$emit('saved')
            this.$emit('update:is-add', false)
            this.resetForm()
          } else {
            this.$swal({
              title: 'Error!',
              text: 'Hubo un error al ' + (this.isEdit ? 'actualizar' : 'registrar') + ' el contenedor',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
          this.isDisabled = false
        }
      })
    },
  },
}
</script>
